import React from 'react';
import { useTranslation } from "react-i18next";


const cards = [
  {
    title: 'mining_technologies_heading',
    description: 'mining_technologies_description',
    backgroundImage: '/assets/servicecardbg1.svg',
  },
  {
    title: 'research_development_heading',
    description: 'research_development_description',
    backgroundImage: '/assets/servicecardbg2.svg',
  },
  {
    title: 'facility_inspections_heading',
    description: 'facility_inspections_description',
    backgroundImage: '/assets/servicecardbg3.svg',
  },
  {
    title: 'support_maintenance_heading',
    description: 'support_maintenance_description',
    backgroundImage: '/assets/servicecardbg4.svg',
  },
  {
    title: 'custom_solutions_heading',
    description: 'custom_solutions_description',
    backgroundImage: '/assets/servicecardbg5.svg',
  },
  {
    title: 'digital_solutions_heading',
    description: 'digital_solutions_description',
    backgroundImage: '/assets/servicecardbg6.svg',
  },
];

const CardInfoSection = () => {
  const { t } = useTranslation("services");

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6  w-full max-w-7xl mx-auto px-4 sm:px-8 mb-[85px]">

      {cards.map((card, index) => (
        <div
          key={index}
          className="relative w-full h-[432px] bg-cover bg-center rounded-[15px] overflow-hidden transition-all duration-500 group"
          style={{ backgroundImage: `url(${card.backgroundImage})` }}
        >
          {/* Hover Overlay */}
          <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-100 border border-[#191919] transition-opacity duration-500"></div>

          {/* Content */}
          <div className="relative z-10 flex flex-col justify-start items-start h-full md:pt-10 md:pl-10 md:pr-7 text-white max-w-[432px] padding-adjustment">
            <h3 className="body-xl-4 tracking-tight text-color-6 mb-2"> {t(card.title)}</h3>
            <p className="body-large-6 tracking-[1px] text-color-9"> {t(card.description)}</p>
          </div>

          {/* Ellipse Animation */}
          <img
            src="/assets/ellipse.svg"
            alt="Ellipse"
            className="absolute bottom-[-100px] right-[-100px] w-40 h-40 opacity-0 group-hover:bottom-2 group-hover:right-2 group-hover:opacity-100 transition-all duration-700"
          />
        </div>
      ))}
    </div>
  );
};

export default CardInfoSection;